// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".switch-enter-from,.switch-leave-to{opacity:0;transform:translateY(10px)}.switch-enter-to,.switch-leave-from{opacity:1;transform:translateY(0)}.switch-enter-active,.switch-leave-active{transition:all .5s ease}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
